import * as R from "ramda";
import axios from "../../axios-auth";

const state = {
  editorFiles: {}
};

const getters = {
  getEditorFiles: state => {
    return R.pathOr([], ["editorFiles"], state);
  },
  findEditorFiles: state => uuid => {
    return R.pathOr(null, ["editorFiles", uuid], state);
  }
};

const mutations = {
  addEditorFile: (state, item) => {
    state.editorFiles = {
      ...state.editorFiles,
      [item.uuid]: item
    };
  }
};

const actions = {};

export default {
  state,
  mutations,
  actions,
  getters
};
